// @core/api/endpoints/workflow/resolve_pipeline_context.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ResolvePipelineContextRequest,
  ResolvePipelineContextResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Resolve pipeline context
 * Resolves the effective pipeline policy for a scope entity by merging the policy hierarchy. Returns merged policy, available templates, and allowed node types.
 */
export async function ResolvePipelineContext(
  data: ResolvePipelineContextRequest,
  options?: RequestOptions
): Promise<ResolvePipelineContextResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/pipelines/resolve-context`;
  const requestOptions = options;
  return client.post<ResolvePipelineContextResponse>(requestPath, data, requestOptions);
}
